
import { defineComponent, ref } from 'vue'

import Home from './components/Home.vue'

export default defineComponent({
  name: 'App',
  components: {
    Home,
  },
  setup() {
    const user = 'uninen'
    const isDj = true
    const djDashboardUrl = '/dj/'
    const isAdmin = false
    const isAnonymous = false
    const debug = process.env.NODE_ENV === 'development'
    const open = ref(false)
    const version = '0.1a'

    return {
      user,
      isDj,
      isAdmin,
      isAnonymous,
      debug,
      open,
      version,
      djDashboardUrl,
    }
  },
})
